import {GETSTATICPAGESTATS, GETSTATICPAGEONE, GETSTATICPAGE, GETPAGEFILTER} from '../actions/constant';

const INITIAL_STATE = {
    stats: {},
    page_one: {},
    pages: {}
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case GETSTATICPAGESTATS:
            return {...state, stats:action.payload.data}; 
        case GETSTATICPAGEONE:
            return {...state, page_one:action.payload.data};      
        case GETSTATICPAGE:
            return {...state, pages:action.payload.data};
        case GETPAGEFILTER:
            return {...state, pages:action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_static_page.js